import React, { useContext } from 'react'
import './Related.css'
import Item from '../Item/Item';
import { useProduct } from '../../Context/ProductContext';
import { useNav } from '../../Context/NavContext';
import { useEffect } from 'react';
import { useState } from 'react';
import { UrlContext } from '../../Context/UrlContext';

function Related() {

    const { apiBaseUrl } = useContext(UrlContext);

    const { setProductDetails } = useProduct();
     const { setActiveItem } = useNav();
     const [products, setProducts] = useState([]);
     const [loading, setLoading] = useState(true);
     const [error, setError] = useState(null);
 
     useEffect(() => {
         const fetchProducts = async () => {
             try {
                 const response = await fetch(`${apiBaseUrl}/products`, {
                     headers: {
                         'Accept': 'application/json',
                         'Content-Type': 'application/json'
                     }
                 });
 
                 if (!response.ok) {
                     throw new Error('Failed to fetch products');
                 }
 
                 const data = await response.json();
                 setProducts(data);
                 setLoading(false);
             } catch (err) {
                 console.error('Error fetching products:', err);
                 setError(err.message);
                 setLoading(false);
             }
         };
 
         fetchProducts();
     }, []);
 
     const handleClick = (product) => {
         setProductDetails(product);
         setActiveItem('PRODUCT');
         window.scrollTo(0, 0);
     };
 
     if (loading) {
         return (
             <div className="latest_container loading">
                 <p>Loading products...</p>
             </div>
         );
     }
 
     if (error) {
         return (
             <div className="latest_container error">
                 <p>Error: {error}</p>
             </div>
         );
     }

  return (
       <div className='related_container'>
            {products.length > 0 ? (
                products.map((product) => (
                    <div key={product.id} className="related_item" onClick={() => handleClick(product)}>
                        <Item 
                            image={product.image ? `data:image/jpeg;base64,${product.image}` : null}
                            name={product.name}
                            price={product.price}
                            stock={product.stockCount}
                            sizes={product.sizes}
                        />
                    </div>
                ))
            ) : (
                <div className="no-results">
                    <p>No products available.</p>
                </div>
            )}
        </div>
  )
}

export default Related
